<table mat-table [dataSource]="processesSliced$" class="full-width-table striped-table widget-table" aria-label="Tasks">
    <app-table-column name="name" labelT="PROJECTS.cockpit.project-widget.header-title">
        <ng-template let-row>
            <app-process-widget-table-cell [customerSpaceId]="customerSpaceId" [process]="row" />
        </ng-template>
    </app-table-column>

    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr *matNoDataRow>
        <td style="text-align: center; padding: 20px 0;" [attr.colspan]="displayedColumns.length">
            <!-- <mat-icon svgIcon="empty" style="height: 60px; width: 60px;"></mat-icon> -->
            <app-empty-list></app-empty-list>
        </td>
    </tr>
</table>
